import { toAmount } from './feeAmount.utils';

const LOAN_COST_SECTIONS = ['A', 'B', 'C'];
const OTHER_COST_SECTIONS = ['E', 'F'];

const sumSections = (main, cdSections) =>
  cdSections.reduce((total, cdSection) => total + toAmount(main?.[cdSection]?.totalAmount), 0);

export const computeFeeTotals = ({ main = {}, cashToCloseAmount } = {}) => ({
  loanCosts: sumSections(main, LOAN_COST_SECTIONS),
  otherCosts: sumSections(main, OTHER_COST_SECTIONS),
  cashToClose: toAmount(cashToCloseAmount),
});
